import { appStore } from '../../../../app/AppStore';
import { siteUrlsSelector } from '../../../../app/selectors/SiteUrlsSelectors';
import { CommonErrorCode, GroupErrorCode } from '../../../../ts/helpers/ErrorCodes';
import { L10n } from '../../../../ts/L10n/L10n';
import { IGroupInfo } from '../../../../ts/models/IGroupInfo';
import { IErrorItem, MultipleItemResult } from '../../../../ts/models/MultipleItemResult';
import { Set } from '../../../../ts/models/Set';
import { IError } from '../../../../ts/ServerApi/types/IError';
import { IResult } from '../../../../ts/ServerApi/types/IResponse';
import {
  ContentActionNotification,
  IMultipleResultNotificationOptions,
  MultipleResultNotificationOptions,
} from '../../../../ts/services/ContentActionNotification';
import { ServiceLocator } from '../../../../app/ServiceLocator';
import { Messages } from '../../../../codegen/Localize';

function notify(result: IResult, groups: Set<IGroupInfo>) {
    const contentActionNotification = ServiceLocator.get<ContentActionNotification>('ContentActionNotification');

    // create a notification object for result reporting
    const notification: IMultipleResultNotificationOptions = MultipleResultNotificationOptions.create(
        new MultipleItemResult(groups, result),
        {
        describeSuccessSummary: (successCount: number) => {
            return Messages.deleteGroupsSuccess({ ITEM_COUNT: successCount, ITEM_COUNT_LOC: L10n.localizedCount(successCount)});
        },
        describeErrorSummary: (errorCount: number) => {
            return Messages.deleteGroupsError({ ERROR_COUNT: errorCount, ERROR_COUNT_LOC: L10n.localizedCount(errorCount)});
        },
        describeErrorDetail: (errorItem: IErrorItem<IGroupInfo>) => {
            const siteUrls = siteUrlsSelector(appStore.getState());
            return {
                itemName: errorItem.item.name,
                itemUrl: siteUrls.groupUrl(errorItem.item.id),
                errorMessage: errorMessageFor(errorItem.error, errorItem.item.name)
                };
            }
        }
    );

    // pass the notification object to the service for displaying
    contentActionNotification.notify(notification);
}

function errorMessageFor(error: IError, groupName: string) {
    switch (error.code) {
        case CommonErrorCode.GroupNotFound:
            return Messages.errorGroupNotFound({ ITEM_NAME: L10n.elideIfLong(groupName) });
        case GroupErrorCode.GroupCannotBeDeleted:
            return Messages.errorUnableToDeleteAllUsersGroup({ GROUP_NAME: L10n.elideIfLong(groupName) });
        default:
            return Messages.errorUnknown();
    }
}

export const DeleteGroupsNotificationAction = {
    notify
};

export type DeleteGroupsNotificationAction = typeof DeleteGroupsNotificationAction;
